<template>
  <div>
    <b-modal
      v-show="!modalLoads"
      id="modal-case"
      ref="my-modal"
      cancel-variant="outline-secondary"
      :ok-variant="bVarient"
      :ok-title="bTitle"
      :ok-disabled="loader === true || (selectedState === 'resume' && !confirmResumeState)"
      :no-close-on-backdrop="true"
      cancel-title="Close"
      centered
      :title="$t('DEBTIA_EDIT_CASE_DETAILS')"
      size="lg"
      @ok="submitHandler"
      @hidden="resetModalState"
    >
      <b-overlay
        id="overlay-background"
        :show="loader === true"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-alert
          variant="danger"
          :show="alertErrors.length > 0"
          class="mb-1"
        >
          <div
            v-for="(row, index) in alertErrors"
            :key="index"
            class="alert-body"
          >
            <feather-icon

              icon="InfoIcon"
              class="mr-50"
            />
            {{ row }}
          </div>
        </b-alert>
        <b-form>
          <validation-observer
            ref="manageCaseForm"
            tag="form"
          >
            <b-row>
              <b-col
                v-if="selectedState === 'pause'"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_PAUSE_CASE_DATE')"
                  label-for="cost"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="pause_date"
                    rules="required"
                  >
                    <b-form-datepicker
                      id="pause_date"
                      v-model="details.pause_date"
                      :min="min"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-if="selectedState === 'pause'"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_CASE_RECIEVE_REMINDER')"
                  label-for="receive_reminder"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="receive_reminder"
                    rules="required"
                  >
                    <b-form-checkbox
                      id="receive-reminder"
                      v-model="selected"
                      name="receive_reminder"
                    >
                      Receive reminder
                    </b-form-checkbox>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-if="selectedState === 'terminate' && details.remaining_debt_amount >= 0.1"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_CASE_COST')"
                  label-for="is_cost"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="is_cost"
                    rules="required"
                  >
                    <b-form-checkbox
                      id="is-cost"
                      v-model="confirmCost"
                      name="is_cost"
                      :disabled="createInvoice === false"
                    >
                      Terminate with cost? ( Amount: {{ formatCurrency(details.remaining_debt_amount) }})
                      <!-- need to add amount -->
                    </b-form-checkbox>
                    <small class="text-danger">{{ (createInvoice === false) ? "Client Missing BC customer id, so can't create an invoice" : "" }}</small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-if="selectedState === 'terminate' && details.rki_entry"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_DELETE_RKI_DEBTOR')"
                  label-for="reason"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="RKI Debtor Deletion Reason"
                    rules="required"
                  >
                    <v-select
                      v-model="rki_reason"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="deleteRKIDebtorReasons"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="reason"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-if="selectedState === 'terminate'"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_REASON')"
                  label-for="reason"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="reason"
                    rules="required"
                  >
                    <v-select
                      v-model="details.reason_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="caseReasonOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="reason"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-if="selectedState !== 'resume'"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_DESCRIPTION')"
                  label-for="description"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="description"
                    rules="required"
                  >
                    <b-form-textarea
                      id="textarea-rows"
                      v-model="details.description"
                      :placeholder="$t('DEBTIA_DESCRIPTION')"
                      rows="8"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-if="selectedState === 'resume'"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_CONFIRM_RESUME_STATE')"
                  label-for="confirm_resume_state"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="confirm resume case"
                    :rules="{ required: { allowFalse: false } }"
                  >
                    <b-form-checkbox
                      id="confirm-resume-state"
                      v-model="confirmResumeState"
                      name="confirm resume case"
                    >
                      {{ $t('DEBTIA_CONFIRM_RESUME_STATE') }}
                    </b-form-checkbox>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-if="selectedState === 'resume'"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_CASE_EMPLOYEE_NAME')"
                  label-for="employee_name"
                  class="mb-2"
                >
                  <b-form-input
                    id="employee-name"
                    v-model="details.employee_name"
                    :readonly="selectedState === 'resume'"
                  />
                </b-form-group>
              </b-col>
              <b-col
                v-if="selectedState === 'resume'"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_CASE_PAUSE_DATE')"
                  label-for="cost"
                  class="mb-2"
                >
                  <b-form-datepicker
                    id="pause_date"
                    v-model="details.pause_date"
                    :readonly="selectedState === 'resume'"
                  />
                </b-form-group>
              </b-col>
              <b-col
                v-if="selectedState === 'resume'"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_CASE_DESCRIPTION')"
                  label-for="description"
                  class="mb-2"
                >
                  <b-form-textarea
                    id="textarea-rows"
                    v-model="details.description"
                    rows="8"
                    :readonly="selectedState === 'resume'"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </validation-observer>
        </b-form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BOverlay, BFormCheckbox, BFormTextarea, BFormDatepicker, BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import { required } from '@validations'
import { EventBus } from '@/event-bus'
import axios from '@axios'
import constants from '@/app-configs/constants'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import constants from '@/app-configs/constants'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    vSelect,
    BFormCheckbox,
    BFormDatepicker,
    BFormTextarea,
    BAlert,
  },
  directives: {
    Ripple,
  },
  props: {
    caseData: {
      type: Object,
      required: true,
    },
    selectedState: {
      type: String,
      required: true,
    },
    caseState: {
      type: String,
      required: true,
      default: '',
    },
    bTitle: {
      type: String,
      required: true,
    },
    bVarient: {
      type: String,
      required: true,
    },
    modalLoads: {
      type: Boolean,
      required: true,
    },
    reasonOptions: {
      type: Array,
      required: true,
    },
    headerBtnPressed: {
      type: String,
      required: true,
    },
    createInvoice: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
    // 15th two months prior
    const minDate = new Date(today)
    minDate.setMonth(minDate.getMonth())
    // minDate.setDate(15)
    // 15th in two months
    // const maxDate = new Date(today)
    // maxDate.setMonth(maxDate.getMonth() + 2)
    // maxDate.setDate(15)
    return {
      snowOption: {
        theme: 'snow',
      },
      loader: false,
      details: [],
      selected: true,
      confirmCost: false,
      confirmResumeState: true,
      required,
      state: '',
      user_type: JSON.parse(localStorage.getItem('userData')).data.name,
      modalLoader: true,
      useCaseData: { ...this.caseData },
      alertErrors: [],
      min: minDate,
      args: [{ label: 'test', value: 't' }],
      caseStatus: 1,
      caseReasonOptions: [],
      deleteRKIDebtorReasons: [
        { label: 'BET-Fordring betalt', value: 'BET' },
        { label: 'AIN-Aftale indgået med skyldner', value: 'AIN' },
        { label: 'DØD-Skyldner er afgået ved døden', value: 'DØD' },
        { label: 'TFY-Tvangsakkord fyldestgjort', value: 'TFY' },
        { label: 'GAL-Gældssanering – al gæld bortfalder', value: 'GAL' },
        { label: 'VTT-Varen taget retur', value: 'VTT' },
        { label: 'TAF-Tvangsauktion aflyst', value: 'TAF' },
        { label: 'STR-Der er strid i sagen', value: 'STR' },
        { label: 'DER-Andet – vi ønsker skyldner slettet', value: 'DER' },
      ],
      rki_reason: '',
      defaultCurrency: localStorage.getItem('defaultCurrency'),
    }
  },
  watch: {
    caseData: {
      deep: true,
      handler() {
        this.details = { ...this.caseData }
      },
    },
    caseState: {
      deep: true,
      handler() {
        this.getState(this.caseState)
      },
    },
    bTitle: {
      deep: true,
      handler() {
      },
    },
    selected: {
      deep: true,
      handler() {
      },
    },
    confirmCost: {
      deep: true,
      handler() {
      },
    },
    confirmResumeState: {
      deep: true,
      handler() {
      },
    },
  },
  created() {
    this.getCaseReasonOptions()
  },
  methods: {
    async getState(state) {
      if (state === 'terminate') {
        this.caseStatus = 3
      } else if (state === 'decline') {
        this.caseStatus = 2
      } else if (state === 'pause') {
        this.caseStatus = 4
      } else if (state === 'resume') {
        this.caseStatus = 5
      } else {
        this.caseStatus = 1
      }
    },
    makeSuccessToast() {
      this.$bvToast.toast('Case Details have been successfully updated', {
        title: 'Success',
        variant: 'success',
        solid: false,
      })
    },
    submitHandler(evt) {
      evt.preventDefault()
      return new Promise((resolve, reject) => {
        if (this.confirmResumeState) {
          this.alertErrors = []
          this.$refs.manageCaseForm.validate().then(success => {
            if (success) {
              this.loader = true
              // const url = `${constants.baseUrl}/update-debt-case`
              this.details.user_id = JSON.parse(localStorage.getItem('userData')).data.id
              this.details.state = this.selectedState
              this.details.receive_reminder = this.selected
              this.details.confirm_resume_state = this.confirmResumeState
              this.details.is_cost = this.confirmCost
              this.details.creditor_id = this.caseData.creditor_id
              this.details.employee_name = JSON.parse(localStorage.getItem('userData')).data.name
              this.details.rki_reason = this.rki_reason
              const data = { ...this.details }
              this.getState(this.headerBtnPressed)
              axios.post('update-debt-case', data).then(response => {
                if (response.status === 200) {
                  // if (this.caseState !== 'Resume' && this.caseState !== 'Pause') {
                  this.taskAction(this.details.debt_case_id, this.details.task_id, this.caseStatus)
                  // }
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'Success',
                      icon: 'CoffeeIcon',
                      variant: 'primary',
                      text: 'Case state has been updated successfully.',
                    },
                  })
                  this.loader = false
                  this.$refs['my-modal'].hide()
                  setTimeout(() => {
                    EventBus.$emit('refreshModules')
                    EventBus.$emit('refreshLogs')
                    EventBus.$emit('refreshSecondaryProcesses')
                    EventBus.$emit('refreshStateData')
                    EventBus.$emit('refreshStatmentWidget')
                  }, 1000)
                  if (this.confirmCost) EventBus.$emit('refreshBetalingInvoices')
                  // this.reloadMethod()
                  // window.location.reload()
                }
              }).catch(err => {
                this.loader = false
                if (err.response.data.message) {
                  this.alertErrors.push(err.response.data.message)
                }
              })
            } else {
              this.loader = false
              reject()
            }
          })
        }
      })
    },
    show() {
      this.$refs['my-modal'].show()
    },
    async taskAction(caseId, taskId, status) {
      await axios.post(`${constants.baseUrl}/approve-debt-case`, {
        debt_case_id: caseId,
        status,
        taskId,
      }).then(response => {
        if (response.status === 200) {
          // console.log('done', response)
        }
      })
    },
    async getCaseReasonOptions() {
      const url = '/reasons?dropdown=true'
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.caseReasonOptions = response.data.data
        }
      })
    },
    formatCurrency(amount) {
      return new Intl.NumberFormat('da-DK', { style: 'currency', currency: this.defaultCurrency }).format(parseFloat(amount).toFixed(2))
    },
    resetModalState() {
      this.selected = true
      this.confirmCost = false
      this.confirmResumeState = true
      this.rki_reason = ''
      this.alertErrors = []
      this.details = { ...this.caseData }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
